if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]'
          ),
          button: this.querySelector("button"),
          panel: this.querySelector(".disclosure__list-wrapper"),
        };
        if (this.elements.button) {
          this.elements.button.addEventListener(
            "click",
            this.openSelector.bind(this)
          );
          this.elements.button.addEventListener(
            "focusout",
            this.closeSelector.bind(this)
          );
        }
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

        document.querySelectorAll(".disclosure__link").forEach(item => {
          item.addEventListener("click", function() {
            const value = item.getAttribute("data-value");
            
            const disclosureBtn = findAncestor(item, '.disclosure').querySelector('.disclosure__button span');
            
            if (disclosureBtn) {
              disclosureBtn.textContent = value;
            }
        
            const listWrapper = findAncestor(item, '.disclosure__list-wrapper');
            if (listWrapper) {
              listWrapper.setAttribute("hidden", true);
            }
          });
        });
        
        function findAncestor(element, selector) {
          while ((element = element.parentElement) && !element.matches(selector));
          return element;
        }        
        
        

        var submitBtn = document.querySelector('.localization-form-submit');

        submitBtn.addEventListener("click", this.onItemClick.bind(this));        
      }

      hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (
            this.elements.button.getAttribute("aria-expanded") === "false"
          ).toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) ||
          this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
